import {FavoritesList} from 'features/Dashboard/components/FavoritesList';
import React from 'react';

export const FavoritesPage = () => {
	return <FavoritesList />;
};
